import { Compensation } from "@daytrip/legacy-models";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface CompensationOperatorOptions extends ModelOperatorOptions<Compensation, {}, {}> {}

export class CompensationOperator extends ModelOperator<Compensation, CompensationOperatorOptions, {}, {}, {}> {}
